import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from '../services/api';
import '../styles/Auth.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const tokenFromUrl = searchParams.get('token');
    if (!tokenFromUrl) {
      setError('Érvénytelen token. Kérj új jelszó visszaállító linket.');
    } else {
      setToken(tokenFromUrl);
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    // Validation
    if (!token) {
      setError('Érvénytelen token');
      return;
    }

    if (!password) {
      setError('Kérlek add meg az új jelszót');
      return;
    }

    if (password.length < 6) {
      setError('A jelszónak legalább 6 karakter hosszúnak kell lennie');
      return;
    }

    if (password !== confirmPassword) {
      setError('A jelszavak nem egyeznek');
      return;
    }

    setLoading(true);

    try {
      const response = await auth.resetPassword(token, password);
      setMessage(response.data.message || 'Jelszó sikeresen megváltoztatva! Átirányítás a bejelentkezéshez...');

      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      console.error('Reset password error:', err);
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('Hiba történt. Kérlek próbáld újra később.');
      }
    } finally {
      setLoading(false);
    }
  };

  // If no token, show error state
  if (!token && !loading) {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <div className="auth-card">
            <h1>Érvénytelen link</h1>
            <div className="alert alert-error">
              Ez a jelszó visszaállító link érvénytelen vagy lejárt.
            </div>
            <div className="auth-links">
              <Link to="/forgot-password" className="btn btn-primary btn-block">
                Új jelszó visszaállító link kérése
              </Link>
            </div>
            <div className="auth-links" style={{ marginTop: '1rem' }}>
              <Link to="/login" className="auth-link">
                ← Vissza a bejelentkezéshez
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <h1>Új jelszó beállítása</h1>
          <p className="auth-subtitle">
            Add meg az új jelszavadat a fiókod visszaállításához.
          </p>

          {error && <div className="alert alert-error">{error}</div>}
          {message && <div className="alert alert-success">{message}</div>}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="password">Új jelszó</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Legalább 6 karakter"
                disabled={loading}
                required
                minLength={6}
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Új jelszó megerősítése</label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Írd be újra a jelszót"
                disabled={loading}
                required
                minLength={6}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={loading}
            >
              {loading ? 'Mentés...' : 'Jelszó megváltoztatása'}
            </button>
          </form>

          <div className="auth-links">
            <Link to="/login" className="auth-link">
              ← Vissza a bejelentkezéshez
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
